import React, { Fragment, useContext, useEffect, useState } from 'react';
import Sidebar from '../../../layouts/global/dashboard/Sidebar';
import TopHeader from '../../../layouts/global/dashboard/TopHeader';
import { AuthContext } from '../../../contexts/AuthContext';
import { Redirect } from 'react-router';
import FundStatistics from '../../../layouts/dashboard/FundStatistics';
import PageTitle from '../../../layouts/global/dashboard/PageTitle';
import axios from 'axios';
import TotalBeneficiaries from '../../../layouts/dashboard/TotalBeneficiaries';
import TotalRewards from '../../../layouts/dashboard/TotalRewards';
import TotalRewardsCard from '../../../layouts/dashboard/TotalRewardsCard';

export default function Dashboard() {
  const { state } = useContext(AuthContext);
  const [stats, setStats] = useState(null);
  const token = localStorage.getItem('token');
  const [loading, setLoading] = useState(true);
  const loadStats = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        'https://secret-ridge-31139.herokuapp.com/api/dashboard_statistics',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    let mounted = true;
    loadStats().then((res) => {
      if (mounted) {
        setStats(res);
        setLoading(false);
      }
    });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <Fragment>
      {state.isAuth ? <Redirect to="/dashboard" /> : <Redirect to="/login" />}
      <div>
        <main className={'flex flex-col lg:flex-row'}>
          <Sidebar />
          <TopHeader />
          <section className={'lg:w-full bg-gray-100 min-h-screen'}>
            <div
              className={
                'w-full px-5 lg:pl-72 pt-20 lg:pt-16 lg:pr-10 bg-gray-100'
              }
            >
              <PageTitle title={'Dashboard'} />
              <div className={'flex flex-col lg:flex-row'}>
                <div className={'w-full lg:w-2/3'}>
                  {stats && <TotalRewards stats={stats} />}
                  {stats && <TotalBeneficiaries stats={stats} />}
                  <div className={'mt-3 p-2'}></div>
                </div>
                <div className={'w-full lg:w-1/3 pl-0 lg:pl-5'}>
                  {stats && (
                    <FundStatistics
                      stats={stats.total_funds}
                      loading={loading}
                    />
                  )}
                  {stats && <TotalRewardsCard stats={stats} />}
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </Fragment>
  );
}
